import { Templates } from '../../compile';
import { ColumnOptions } from '../../interfaces/options';
import { Align } from '../../enums';
import { ID } from '..';

export function DefaultBaseTableCommandColumnOptions<T>(): ColumnOptions<T> {
	return <ColumnOptions<T>>{
		key: ID.Commands,
		label: ' ',
		autoWidth: true,
		isFilterable: false,
		template: Templates.table_column_commands,
		headerAlign: Align.RIGHT,
		cellAlign: Align.RIGHT
	};
}
